









































































import {computed, ComputedRef, defineComponent, PropType} from '@vue/composition-api'
import {IActivity} from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel"
import {isBetweenDates} from "@/apps/MyStudyChoiceActivitiesWidget/mixins/ActivityMixins"
import {useGetters} from "vuex-composition-helpers";
import TitleAtom from "@/shared/components/atoms/card/TitleAtom.vue"
import ActionAtom from "@/shared/components/atoms/card/ActionAtom.vue"
import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue"
import DateAtom from "@/shared/components/atoms/card/DateAtom.vue"

export default defineComponent({
    name: "AvailableActivity",
    components: {TitleAtom, ActionAtom, DateAtom, ButtonLinkAtom},
    props: {
        activity: {
            type: Object as PropType<IActivity>,
            required: true
        },
        interactive: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup: () => {
        const {getConfig} = useGetters(['getConfig'])

        const hasSurvey: ComputedRef<boolean> = computed((props): boolean => {
            return !props.activity.surveyCompleted
                && isBetweenDates({
                    today: new Date,
                    from: props.activity.surveyStartDate,
                    to: props.activity.surveyEndDate,
                })
                && props.activity.surveyUrl !== ''
        })

        const surveyUrl: ComputedRef<string> = computed((props): string => {
            return `${props.activity.surveyUrl}&CIAM_ID=${getConfig.value.ciamId}&EVENT_CODE=${props.activity.eventCode}`
        })

        const canWatch: ComputedRef<boolean> = computed((props): boolean => {
            let today = new Date()
            return new Date(props.activity.eventWatchableUntil).getTime() >= today.getTime()
        })

        return {
            getConfig,
            hasSurvey,
            canWatch,
            surveyUrl
        }
    }
})
